var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from '@emotion/styled';
import { lineHeight, fontSize, maxWidth, order, space } from 'styled-system';
import { Text } from '../../common/components/Text';
import CountDown from '../../common/components/CountDown';
export var EllipsisParagraph = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), space, maxWidth, order);
EllipsisParagraph.defaultProps = {
    mt: 0,
    maxWidth: ['300px', null, '400px', '550px'],
};
var CampaignDuration = styled(EllipsisParagraph)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n"])), lineHeight, fontSize, space);
CampaignDuration.defaultProps = __assign(__assign({}, EllipsisParagraph.defaultProps), { as: 'p', margin: 0, lineHeight: [1, 3] });
var CampaignInfoContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex: 1;\n  ", ";\n  ", ";\n"], ["\n  flex: 1;\n  ", ";\n  ", ";\n"])), space, order);
CampaignInfoContainer.defaultProps = {
    order: [3, 1],
};
var CampaignInfo = function (_a) {
    var duration = _a.duration, countDown = _a.countDown;
    return (React.createElement(CampaignInfoContainer, { "data-testid": "campaign-info" },
        duration && (React.createElement(CampaignDuration, { "data-testid": "campaign-duration" }, duration)),
        countDown && countDown.endDate && (React.createElement(CountDown, { label: countDown.label, endDate: countDown.endDate }))));
};
export default CampaignInfo;
var templateObject_1, templateObject_2, templateObject_3;
